
import { mapMutations, mapState } from 'vuex'
import moment from 'moment';
import { defineComponent } from '@vue/runtime-core';
import { Solve } from '@/interface/timer/solve.interface';

export default defineComponent({
    name: 'TimeList',
    data(){
        return {
          loading: true,
          small: true,
          timeList: [],
          sessionList: [],
          stats: {},
          currSession: this.currentSession
        }
    },
    props: {
      toggles: Boolean
    },
    watch:{
      toggles: function(newVal, oldVal) {
        if (this.small) {
          const tList = document.querySelector('#tList');
          tList!.classList.toggle('-translate-x-full')
          console.log(`timelist ${newVal} from ${oldVal}`)
        }
      }
    },
    mounted() {
      this.checkSmallScreen();
      window.addEventListener('resize', this.checkSmallScreen);
    },
    methods: {
      handleSessionChange(event: Event) {
        let newSession = this.allSessions.filter((s: any) => {
          return s.doc.name == (event.currentTarget! as HTMLSelectElement).value
        })[0]
        
        this.SetCurrentSession(newSession.doc)
      },
      parseTime(time: number, penalty: number): string{
        if (penalty == 2) return "DNF"
        var minutes = moment.duration(time).minutes();
        var formattedTime = minutes == 0 ? moment.utc(time).format('ss.SS') : moment.utc(time).format('mm:ss.SS')
        return penalty == 0 ? formattedTime : `${formattedTime}+`
      },
      checkSmallScreen(): void {
        let windowWidth = window.innerWidth;
        if (windowWidth <= 767){
          this.small = true;
          return;
        }
        this.small = false;
      },
      getAverage(n: number): string {
        if (this.currentSession.solveList.length < n) return 'N/A'

        let listOfSolves: Array<Solve> = this.currentSession.solveList.slice(0, n);

        let total = 0;
        let average = 0;
        let maxTime: Solve;
        let minTime: Solve;

        // check if multiple dnf exists return dnf
        let dnfsInList: Array<Solve> = listOfSolves.filter(solve => solve.penalty == 2)
        if (dnfsInList.length > 1) return 'DNF'
        if (dnfsInList.length == 1) {
          maxTime = dnfsInList[0];
        }else {
          maxTime = listOfSolves.filter(solve => solve.time == Math.max(...listOfSolves.map(item => item.time)))[0]
        }
        minTime = listOfSolves.filter(solve => solve.time == Math.min(...listOfSolves.map(item => item.time)))[0]

        let countingSolves: Array<Solve> = listOfSolves.filter(solve => solve !== minTime).filter(solve => solve !== maxTime);

        countingSolves.forEach(solve => {
          total += solve.time;
        });

        average = total / (n-2);
        var minutes = moment.duration(average).minutes();
        return minutes == 0 ? moment.utc(average).format('ss.SS') : moment.utc(average).format('mm:ss.SS')
      },
      getMean(n: number): string{
        if (this.currentSession.solveList.length < n) return 'N/A'

        let listOfSolves: Array<Solve> = this.currentSession.solveList.slice(0, n);
        let dnfsInList: Array<Solve> = listOfSolves.filter(solve => solve.penalty == 2)

        if (dnfsInList.length > 0) return 'DNF'

        let total = 0;
        let mean = 0;

        listOfSolves.forEach(solve => {
          total += solve.time;
        });

        mean = total / n;
        var minutes = moment.duration(mean).minutes();
        return minutes == 0 ? moment.utc(mean).format('ss.SS') : moment.utc(mean).format('mm:ss.SS')

      },
      ...mapMutations('modalModule', ['ToggleModal', 'ToggleSolveModal', 'ToggleSessionDeleteModal']),
      ...mapMutations('sessionsModule', ['SetCurrentSession'])
    },
    computed: {
      ...mapState('sessionsModule', ['currentSession']),
      ...mapState('sessionsModule', ['allSessions']),
    }
})
